import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <IndexSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <TopicsSection />
        <CommentsSection />
        <CarouselSection />
        <FaqSection />
        <FeaturesSection />
        <RankingSection />
        <MediaSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}